<template></template>
<script>
export default {
  data () {
    return {
      supportDatasources: []
    }
  },
  computed: {
    consultantPreKey: function () {
      // 咨询人前缀
      return process.env.VUE_APP_IM_SYSTEM_USER_PRE + 'consultant_'
    },
    userAccount: function () {
      return this.$store.getters['userInfo/account']
    },
    isAdmin: function () {
      return this.$store.getters['userInfo/isAdmin'] || false
    },
    imUserId: function () {
      return process.env.VUE_APP_IM_SYSTEM_USER_PRE + this.userAccount
    },
    imLawyerStatus: function () {
      return this.$store.getters['lawyerInfo/lawyerStatus']['IM']
    },
  },
  methods: {
    loadDataSource: function () {
      let that = this
      this.$axios.post('/api/IMServerCommon/getIMSupportDS').then(res => {
        if (res.success) {
          that.supportDatasources = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('获取IM支持数据源失败！')
      })
    },
    init: function () {
      if (process.env.VUE_APP_RONGYUN_KEY) {
        console.log('process.env.VUE_APP_RONGYUN_KEY', process.env.VUE_APP_RONGYUN_KEY)
        if (RongIMLib) {
          const Events = RongIMLib.Events
          //只初始化一次
          RongIMLib.init({ appkey: process.env.VUE_APP_RONGYUN_KEY })
          console.log('RongIMLib init finish')
          this.getIMToken()
        } else {
          this.$Message.error('当前IM不可用！')
        }
      } else {
        throw new Error("rongyun key is empty")
      }
    },
    destroy: function () {
      try {
        if (RongIMLib) {
          RongIMLib.disconnect().then(() => {
            // debugger
            console.log('成功断开')
          })
        }
      } catch (error) {
        console.log('RongIMLib destroy error', error)
      }
    },
    getIMToken: function () {
      let that = this
      this.$axios.post('/api/IMServerCommon/getIMToken').then(res => {
        if (res.success) {
          that.imToken = res.result
          that.initIM()
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('获取IMToken失败！')
      })
    },
    initIM: function () {
      let that = this
      try {
        const Events = RongIMLib.Events
        // 移除具体事件的所有监听器
        RongIMLib.removeEventListeners(Events.CONNECTING)
        RongIMLib.removeEventListeners(Events.CONNECTED)
        RongIMLib.removeEventListeners(Events.DISCONNECT)
        RongIMLib.removeEventListeners(Events.SUSPEND)
        RongIMLib.removeEventListeners(Events.MESSAGES)

        /**
         * 正在链接的事件状态
         */
        RongIMLib.addEventListener(Events.CONNECTING, () => {
          console.log('正在链接...')
        })

        /**
         * 链接到服务器会触发这个事件
         */
        RongIMLib.addEventListener(Events.CONNECTED, () => {
          console.log('连接成功')
        })

        /**
         * 手动调用 disconnect 方法或者用户被踢下线 会触发这个事件
         */
        RongIMLib.addEventListener(Events.DISCONNECT, (code) => {
          console.log('连接中断，需要业务层进行重连处理 ->', code)
          // this.$notify({ type: 'danger', message: "当前咨询已断开链接，请手动刷新重试！" })
          // this.$Message.error('当前咨询已断开链接，请尝试重新接入！')
          that.$Notice.error({ title: "即时通信IM已断开链接！" })
          // that.changeIMStatus("offline")
          that.$bus.$emit('statusChange', { type: 'offline' })
          that.disconnect = true
        })

        /**
         * 链接出问题时，内部进行重新链接，会触发这个事件
         */
        RongIMLib.addEventListener(Events.SUSPEND, (code) => {
          console.log('链接中断，SDK 会尝试重连，业务层无需关心')
          // 5.1.2 版本开始，事件回调中会引起中断的 code 状态码
          that.$Notice.warning({ title: "即时通信IM链接中断，正在尝试重连！" })
          console.log(`code -> ${code}`)
        })

        /**
         * reconnectKickEnable 参数详细说明：
         * 设置 reconnectKickEnable 为 true： 如果重连时发现已有别的桌面端设备在线，将不再重连，不影响已正常登录的桌面端设备。
         * 设置 reconnectKickEnable 为 false：如果重连时发现已有别的桌面端设备在线，将踢出已在线的桌面端设备，使当前设备上线。
         */
        RongIMLib.connect(this.imToken, false).then(async (resRY) => {
          if (resRY.code === RongIMLib.ErrorCode.SUCCESS) {
            console.log('连接用户为: ', resRY.data)
            // await that.changeIMStatus("online")
            that.$bus.$emit('statusChange', { type: 'online' })
            that.$Notice.success({ title: "即时通信IM链接成功！" })
          } else {
            that.$Notice.error(resRY?.message || 'IM链接失败！')
          }
        })

        RongIMLib.addEventListener(Events.MESSAGES, (ev) => {
          console.log('收到的消息...', ev.messages)
          let routeName = that.$route.name
          ev.messages.forEach(item => {
            if (item.messageUId != that.lastMessageUId && item.isOffLineMessage != true) {
              let extra = item.content?.extra
              let msg = item.content?.content
              that.lastMessageUId = item.messageUId
              switch (extra) {
                case 'create':
                  // 若律师非上线的 不收到提醒
                  if (!this.imLawyerStatus && !this.isAdmin) break
                  // 系统收到新的咨询件  内容就是当前咨询件数据来源
                  console.log('that.$route.name', that.$route.name)
                  if (that.supportDatasources.indexOf(msg) >= 0) {
                    that.$bus.$emit('statusChange', { type: 'receive', message: '新的咨询件' })
                    if (routeName == 'IMServergrabbingHall') {
                      //当前在抢单大厅
                      that.$Notice.info({
                        title: '系统收到新的咨询件',
                      })
                      that.$bus.$emit('reload')
                    } else {
                      that.$Notice.info({
                        title: '新的咨询件',
                        desc: '系统收到新的咨询件，请前往抢单列表查询！',
                        duration: 5,
                      })

                    }
                    that.$bus.$emit('refreshIM')
                  }
                  break
                case 'access':
                  //咨询件被消化
                  if (item.targetId.indexOf(process.env.VUE_APP_IM_SYSTEM_USER_PRE + 'SYSTEM_IM_GROUP') >= 0) {
                    // 表示系统提醒 咨询件被消耗
                    if (routeName == 'IMServergrabbingHall') {
                      //当前在进行中
                      this.$bus.$emit('reload')
                    }
                    this.$bus.$emit('refreshIM')
                  } else {
                    // 打开咨询框
                    // if (!this.showIM) this.showIM = true
                    //律师接入
                    this.$bus.$emit('statusChange', { type: 'access' })
                    this.$Notice.info({
                      title: '您有一件新的咨询件待回复！',
                      duration: 5
                    })
                    if (routeName == 'IMServercharting') {
                      // 当前正在咨询中界面
                      this.$bus.$emit('getIMList', true)
                    } else {
                      // 跳转到聊天界面
                      this.$router.push({ name: 'IMServercharting', params: { groupId: item.targetId } })
                    }
                  }
                  break
                case 'destroy':
                  //咨询件被销毁
                  if (routeName == 'IMServergrabbingHall') {
                    //抢单列表刷新
                    this.$bus.$emit('reload')
                  }
                  this.$bus.$emit('refreshIM')
                  break
                case 'finish':
                  //结束 todo
                  this.$bus.$emit('statusChange', { type: 'finish' })
                  // 将消息发送进聊天框
                  this.$bus.$emit('message', item)
                  // if (this.imLawyerStatus || this.isAdmin) {
                  this.$Notice.warning({
                    // title: item.content?.content || '您有一件咨询件已结束咨询，聊天室将于3秒后主动关闭！',
                    title: '咨询结束',
                    duration: 3,
                    desc: '您有一件咨询件已结束咨询，聊天室将于3秒后主动关闭！'
                  })
                  // }
                  if (routeName == 'IMServercharting') {
                    // 当前正在咨询中界面
                    setTimeout(() => {
                      this.$bus.$emit('finish', item)
                    }, 3000)
                  } else if (routeName == 'IMServerconsultantongoing') {
                    //当前在进行中
                    this.$bus.$emit('reload')
                  }
                  break
                case 'interpose':
                  // 表示有律师介入咨询件 或者被指派介入咨询
                  if (routeName == 'IMServerconsultantongoing') {
                    //当前在进行中
                    this.$bus.$emit('reload')
                  }
                case 'auto':
                  if (item.senderUserId.indexOf(this.consultantPreKey) >= 0) {
                    if (routeName != 'IMServercharting') {
                      // 不正在咨询中界面
                      this.$Notice.warning({
                        title: '新消息',
                        // desc: '收到咨询人信息，请及时回复！',
                        duration: 5,
                        render: (h, params) => {
                          return h('div', [
                            h('span', '收到咨询人信息，请及时'),
                            h('a', {
                              props: {
                                type: 'text',
                              },
                              attrs: {
                                style: 'padding: 0;  color: #009EFC!important;',
                              },
                              on: {
                                'click': () => {
                                  // this.viewChartHis(params.row)
                                  that.$router.push({ name: 'IMServercharting', params: { groupId: item.targetId } })
                                }
                              },
                            }, '回复'),
                          ])
                        }
                      })
                    }
                    that.$bus.$emit('statusChange', { type: 'message', message: '收到新消息' })
                  }
                default:
                  this.$bus.$emit('getIMList')
                  this.$bus.$emit('message', item)
                  break
              }
            } else {
              console.log('repeat message...')
            }
          })
        })
      } catch (error) {
        console.log('initIM error', error)
      }
      // this.currentChartRoom()
    }
  },
  beforeMount () {
    this.loadDataSource()
    this.init()
  },
  beforeDestroy () {
    this.destroy()
  }
}
</script>